$(document).ready(function () {
    setTimeout(function () {
        $('a.flex-next').attr('role','button');
    }, 3000);
    }, 3000);

    $('br').attr('aria-hidden', 'true');

    $(document).ready(function(){
        $('.a').click(function(){
          $(this).toggleClass('active');
          $(this).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
          });
      });
      })
      $(document).ready(function () {
        setTimeout(function () {
      $('iframe#ztb-cf-widget').attr('title','zotabox form');
      $('.facebook iframe').attr('title','Mighty Bright On Facebook this link open in a new tab');
      $('.twitter iframe').attr('title','Mighty Bright On Twitter this link open in a new tab');
      $('.prorw__product_review_popup_star_ratings.prorw-starratings.prorw-review-header-starratings').attr('role','img');
      $('.carousel.slick-initialized.slick-slider i.prev_slide').attr('aria-label','Previous');
      $('.carousel.slick-initialized.slick-slider i.prev_slide').attr('role','button');
      $('.carousel.slick-initialized.slick-slider i.next_slide').attr('aria-label','Next');
      $('.carousel.slick-initialized.slick-slider i.next_slide').attr('role','button');
      // $('.twitter').attr('aria-label','Mighty Bright On Twitter this link open in a new tab');
      // $('.twitter').attr('role','link');
      // $('.facebook').attr('aria-label','Mighty Bright On Facebook this link open in a new tab');
      // $('.facebook').attr('role','link');
    }, 3000);
  }, 3000);

$(document).ready(function() {
    setInterval(function() {
        $('li.gallery-slider').each(function() {
            var $this = $(this);
            var ariaHidden = $this.attr('aria-hidden');
            
          if ($this.hasClass('flex-active-slide')) {
            $this.attr('aria-hidden', 'false');
        } else {
            $this.attr('aria-hidden', 'true');
        }
        });
    }, 1000); 
});

$(document).ready(function () {
  setTimeout(function () {
    var secondImageAlt = $('img.zoomImg').attr('alt');
    var targetImage = $('ol.flex-control-nav.flex-control-thumbs li img');
    targetImage.attr('alt', secondImageAlt);
}, 3000);
}, 2000);

$(document).ready(function() {
  var searchInput = $('ul.slides');
  var suggestionList = $('.flex-direction-nav');

  suggestionList.insertAfter(searchInput);
});

document.addEventListener('DOMContentLoaded', function () {
  // Select all navigation links
  const navigationLinks = document.querySelectorAll('#big-footer a, .submenu a'); // Replace '.site-nav a' with your actual navigation link selector

  navigationLinks.forEach(function (link) {
    // Get the text content of the link
    const linkText = link.textContent.trim();

    // Check if the link is external
    const linkHost = new URL(link.href).host;
    const currentHost = window.location.host;
    const isExternal = linkHost !== currentHost;

    // If the link is external, add target="_blank"
    if (isExternal) {
      link.setAttribute('target', '_blank');
    }

    // Check if the link opens in a new tab
    const newTabNotice = link.target === '_blank' ? ', this link will open in a new tab' : '';

    // Add the text content and new tab notice as the aria-label attribute
    if (linkText) {
      link.setAttribute('aria-label', linkText + newTabNotice);
    }
  });
});
